const paginationMixin = {
  data() {
    return {
      totalItems: 0,
      totalPages: 0,
    };
  },
  methods: {
    mapPagination(data) {
      this.totalItems = data.data.totalItems;
      this.totalPages = data.data.totalPages;
      this.currentPage = data.data.currentPage;
    },
  },
};
export default paginationMixin;
